import { alpha, useTheme } from '@mui/material/styles'
import { ChatHeader } from './ChatHeader'
import { MessageList } from './MessageList'
import { MessageInput } from './MessageInput'
import { TypingIndicator } from './TypingIndicator'
import { useChat } from '../context/ChatProvider'

export const ChatWindow = () => {
  const theme = useTheme()
  const { loading, error, messages, typingParticipant } = useChat()

  return (
    <div className="min-h-[80vh] h-[calc(100vh-4rem)] w-full bg-[#F6F7F9] px-4 py-8">
      <div
        className="mx-auto flex h-full max-w-5xl flex-col rounded-[32px] border bg-white shadow-[0_20px_50px_rgba(15,23,42,0.08)]"
        style={{ borderColor: alpha(theme.palette.primary.main, 0.15) }}
      >
        <ChatHeader />
        <div className="flex-1 overflow-hidden">
          <div className="flex h-full flex-col">
            {loading && (
              <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center text-slate-500">
                <div
                  className="h-12 w-12 animate-spin rounded-full border-4"
                  style={{
                    borderColor: alpha(theme.palette.primary.main, 0.15),
                    borderTopColor: theme.palette.primary.main,
                  }}
                />
                <p className="text-sm font-medium">Connecting to chat…</p>
              </div>
            )}
            {!loading && error && messages.length === 0 && (
              <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
                <p className="text-base font-semibold text-slate-700">
                  Something went wrong
                </p>
                <p className="mt-2 text-sm text-slate-500">{error}</p>
              </div>
            )}
            {!loading && (!error || messages.length > 0) && (
              <MessageList
                messages={messages}
                footer={
                  typingParticipant ? (
                    <TypingIndicator name={typingParticipant} />
                  ) : null
                }
              />
            )}
          </div>
        </div>
        <div className="border-t border-slate-100 px-6 py-5">
          <MessageInput />
        </div>
      </div>
    </div>
  )
}
